import { render, staticRenderFns } from "./cliente.vue?vue&type=template&id=846d2866&scoped=true&"
import script from "./cliente.vue?vue&type=script&lang=js&"
export * from "./cliente.vue?vue&type=script&lang=js&"
import style0 from "./cliente.vue?vue&type=style&index=0&id=846d2866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846d2866",
  null
  
)

export default component.exports